import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
library.add(faCircleNotch);

interface IProps {
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  onToggle: () => void;
  isOpen: boolean;
  isLoading: boolean;
}

export const SaveDraftAnnotationsModal = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_Modal
      isOpen={props.isOpen}
      toggle={props.onToggle}
      headerText={t('warning')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.onToggle}
          >
            {t('cancel')}
          </Button>

          <Button
            variant='outlined'
            onClick={props.onCancel}
          >
            {t('do_not_save')}
          </Button>
          <Button
            onClick={() => {
              void props.onConfirm();
            }}
            disabled={props.isLoading}
            loading={props.isLoading}
          >
            {t('save')}
          </Button>
        </>
      }
    >
      {t('do_you_want_to_save_your_current_work')}
    </S_Modal>
  );
});
